export const GUEST_LOGIN           = "GUEST_LOGIN";
export const GUEST_LOGOUT          = "GUEST_LOGOUT";
export const GUEST_SUGGEST_ACCOUNT = "GUEST_SUGGEST_ACCOUNT";